import React, { Component, PropTypes } from 'react';
import Select from 'react-select';
import _ from 'underscore';

const Game = ({ id, name, gameGroup, sides }) => (
  <div key={id}>{name} - {gameGroup.type}: {gameGroup.name} - {gameGroup.division.name}</div>
);

/**
 * A component that searches games and uses the results to populate a select
 */
export default class GameSelect extends Component {
  static contextTypes = {
    dao: PropTypes.object.isRequired
  };

  static propTypes = {
    params: PropTypes.object
  };

  static defaultProps = {
    params: null,
    valueRenderer: Game,
    optionRenderer: Game,
    filterOption: (game, input) => true,
    tabSelectsValue: false,
    autosize: false,
    valueKey: 'id',
    minimumInput: 1,
    autoload: false,
    placeholder: 'Select...'
  };

  state = {
    paramKey: 0
  };

  componentWillReceiveProps({ params }) {
    if (!_.isEqual(params, this.props.params)) {
      this.setState({ paramKey: this.state.paramKey + 1 });
    }
  }

  fetchGames = _.debounce((input, callback) => {
    const { params } = this.props;
    const { dao } = this.context;

    dao.games.get({
      ...params,
      gameNameSearch: input,
      count: 20
    }).then(
      ({ results: games }) => callback(null, { options: games, complete: false }),
      err => callback(err.message)
    );
  }, 400);

  focus() {
    const { select } = this.refs;
    select.focus();
  }

  handleChange = games => {
    const { onChange, multi } = this.props;
    if (!multi && _.isArray(games)) {
      onChange(null);
    } else {
      onChange(games);
    }
  };

  render() {
    const { paramKey } = this.state;
    const { params, ...rest } = this.props;

    return (
      <Select.Async
        ref="select"
        key={paramKey}
        {...rest}
        onChange={this.handleChange}
        loadOptions={this.fetchGames}
      />
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/inputs/GameSelect.jsx